import type {RelationshipConstraint} from '@packages/systems/constraints-types';

export const SHARED_INPUT_WRAPPER_CONSTRAINTS_DESCENDANTS: RelationshipConstraint[] =
  [
    {is: 'FormBlockLabel', rule: 'Forbid'},
    {is: 'FormButton', rule: 'Forbid'},
    {is: 'FormCheckboxWrapper', rule: 'Forbid'},
    {is: 'FormFileUploadWrapper', rule: 'Forbid'},
    {is: 'FormRadioWrapper', rule: 'Forbid'},
    {is: 'FormReCaptcha', rule: 'Forbid'},
    {is: 'FormSelect', rule: 'Forbid'},
    {is: 'FormTextarea', rule: 'Forbid'},
    {is: 'FormTextInput', rule: 'Forbid'},
  ];
